// @ts-ignore
import AppStoreSK from 'src/layout/footer/assets/apple-sk.webp'
// @ts-ignore
import AppStoreEN from 'src/layout/footer/assets/apple-en.webp'
// @ts-ignore
import AppStoreCZ from './apple-cs.webp'
// @ts-ignore
import AppStorePL from 'src/layout/footer/assets/apple-pl.webp'
// @ts-ignore
import AppStoreHU from 'src/layout/footer/assets/apple-hu.webp'
// @ts-ignore
import AppStoreRO from 'src/layout/footer/assets/apple-ro.webp'
// @ts-ignore
import AppStoreIT from 'src/layout/footer/assets/apple-it.webp'
// @ts-ignore
import GooglePlaySK from 'src/layout/footer/assets/google_play-sk.webp'
// @ts-ignore
import GooglePlayEN from 'src/layout/footer/assets/google_play-en.webp'
// @ts-ignore
import GooglePlayCS from 'src/layout/footer/assets/google_play-cs.webp'
// @ts-ignore
import GooglePlayPL from 'src/layout/footer/assets/google_play-pl.webp'
// @ts-ignore
import GooglePlayUA from 'src/layout/footer/assets/google_play-ua.webp'
// @ts-ignore
import GooglePlayHU from 'src/layout/footer/assets/google_play-hu.webp'
// @ts-ignore
import GooglePlayRO from 'src/layout/footer/assets/google_play-ro.webp'
// @ts-ignore
import GooglePlayIT from 'src/layout/footer/assets/google_play-it.webp'
// @ts-ignore
import GoPay from 'src/layout/footer/assets/gopay.webp'
// @ts-ignore
import Maestro from 'src/layout/footer/assets/maestro.webp'
// @ts-ignore
import Mastercard from 'src/layout/footer/assets/mastercard.webp'
// @ts-ignore
import MastercardElectronic from 'src/layout/footer/assets/mastercard_electronic.webp'
// @ts-ignore
import MastercardSecure from 'src/layout/footer/assets/mastercard_secure.webp'
// @ts-ignore
import Visa from 'src/layout/footer/assets/visa.webp'
// @ts-ignore
import VisaElectron from 'src/layout/footer/assets/visa_electron.webp'
// @ts-ignore
import VisaVerified from 'src/layout/footer/assets/visa_verified.webp'
// @ts-ignore
import Stripe from 'src/layout/footer/assets/stripe_wordmark-blurple.webp'
import { LangDict } from '../../../i18n/lib/texts/types'

export default {
    appStore: {
        SK: AppStoreSK,
        EN: AppStoreEN,
        CS: AppStoreCZ,
        PL: AppStorePL,
        UK: AppStoreEN,
        HU: AppStoreHU,
        RO: AppStoreRO,
        IT: AppStoreIT,
        DE: AppStoreEN
    } as LangDict<any>,
    googlePlay: {
        SK: GooglePlaySK,
        EN: GooglePlayEN,
        CS: GooglePlayCS,
        PL: GooglePlayPL,
        UK: GooglePlayUA,
        HU: GooglePlayHU,
        RO: GooglePlayRO,
        IT: GooglePlayIT,
        DE: GooglePlayEN
    } as LangDict<any>,
    payment: {
        GoPay,
        Maestro,
        Mastercard,
        MastercardElectronic,
        MastercardSecure,
        Visa,
        VisaElectron,
        VisaVerified
    },
    paymentHu: {
        Stripe,
        Maestro,
        Mastercard,
        MastercardElectronic,
        MastercardSecure,
        Visa,
        VisaElectron,
        VisaVerified
    }
}
